import React, { useState } from "react";
import { Box, Container, Divider, Grid, InputLabel, TextField, Typography, Button, FormControl, OutlinedInput, Paper } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

const sections = [
    { title: "For Header", fields: [{ label: "Header Text", id: "txtHeader", type: "text" }] },
    { title: "For Footer", fields: [{ label: "Footer Text", id: "txtFooter", type: "text" }, { label: "URL", id: "txtUrl", type: "text" }] },
];

const SiteSetting = () => {
    const [logoPreview, setLogoPreview] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) setLogoPreview(URL.createObjectURL(file));
    };

    const deleteLogo = () => setLogoPreview(null);

    return (
        <Container maxWidth="md" sx={{ py: 2, minHeight: "100vh" }}>
            <Typography variant="h6" sx={{ mb: 1, fontSize: '0.9rem',fontWeight:'bold' }}>

                Manage Campaign
            </Typography>

            {sections.map((section, index) => (
                <Paper key={index} elevation={2} sx={{ mb: 3, p: 2, borderRadius: 2 }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            p: 1,
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "white",
                            fontSize: "0.9rem",
                            bgcolor: "linear-gradient(to right, #1976d2, #2196f3)",
                            borderRadius: 1,
                        }}
                    >
                        {section.title}
                    </Typography>

                    <Grid container spacing={2} >
                        {section.fields.map((field, idx) => (
                            <Grid item xs={12} key={idx}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label={field.label}
                                    variant="outlined"
                                    id={field.id}
                                    InputLabelProps={{ style: { fontSize: "0.8rem" } }}
                                    inputProps={{ style: { fontSize: "0.8rem", padding: "8px" } }}
                                />
                            </Grid>
                        ))}

                        {index === 0 && (
                            <>
                                <Grid item xs={12}>
                                    <Divider>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            OR
                                        </Typography>
                                    </Divider>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <OutlinedInput
                                            type="text"
                                            placeholder="Choose file..."
                                            sx={{ fontSize: "0.8rem", py: 0.5 }}
                                            endAdornment={
                                                <Button
                                                    component="label"
                                                    variant="contained"
                                                    size="small"
                                                    sx={{ fontSize: "0.7rem", py: 0.5, px: 1 }}
                                                    startIcon={<CloudUploadIcon sx={{ fontSize: 16 }} />}
                                                >
                                                    Upload
                                                    <VisuallyHiddenInput type="file" onChange={handleFileChange} />
                                                </Button>
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                                {logoPreview && (
                                    <Grid item xs={12} textAlign="center">
                                        <Box>
                                            <img
                                                src={logoPreview}
                                                alt="Logo Preview"
                                                width="130"
                                                height="70"
                                                style={{
                                                    //   borderRadius: "8px",
                                                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                                                }}
                                            />
                                            <br />
                                            <Button
                                                variant="text"
                                                size="small"
                                                color="error"
                                                onClick={deleteLogo}
                                                sx={{ fontSize: "0.75rem" }}
                                            >
                                                Delete Logo
                                            </Button>
                                        </Box>
                                    </Grid>
                                )}
                            </>
                        )}

                        {index === sections.length - 1 && (
                            <Grid item xs={12} textAlign="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    sx={{ fontSize: "0.75rem" }}
                                >
                                    Save Changes
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Paper>
            ))}
        </Container>

    );
};

export default SiteSetting;